import React from 'react';
import PropTypes from 'prop-types';
import PressReleasesItem from './PressReleasesItem';

const PressReleasesList = ({ pressreleases }) => (
  <div>
    {
      pressreleases.map(
        (pressrelease, index) => <PressReleasesItem key={index} pressrelease={pressrelease} />,
      )
    }
  </div>
);

PressReleasesList.propTypes = {
  pressreleases: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    pressreleases: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      dates: PropTypes.string.isRequired,
    })),
  })).isRequired,
};
export default PressReleasesList;



// WEBPACK FOOTER //
// ./src/components/PressReleases/components/PressReleasesList.js